import StatusChip from "@common/components/statusChip/StatusChip.tsx";
import { useTranslation } from "@localization/useTranslation";

export interface LegalEntityStatusChipProps {
    isActive: boolean;
}

// Archived reuses the colour contracts and systems already give their end-of-life state, so the three overviews
// read the same.
function LegalEntityStatusChip(props: LegalEntityStatusChipProps) {
    const { translateString } = useTranslation();

    return <StatusChip value={translateString(props.isActive ? "active" : "archived")} status={props.isActive ? "green" : "purple"} />;
}

export default LegalEntityStatusChip;
